export const styles = {
  postItemContainer: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  postItemProfileContainer: {
    display: 'flex',
    width: '100%',
  },
  postItemProfile: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '146%',
    color: '#23252F',
    '& span': {
      color: '#6E707A',
      fontWeight: '400',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  postItemContent: {
    width: '100%',
    display: 'flex',
    fontFamily:
      "'Inter', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Twemoji', sans-serif",
    '& p, a': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      fontSize: '14px',
      lineHeight: '146%',
      fontWeight: 400,
      margin: '0',
      WebkitLineClamp: '2',
      'line-clamp': '2',
      WebkitBoxOrient: 'vertical',
      wordBreak: 'break-all',
    },
    '& p': {
      color: '#424550',
    },
    '& span': {
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#4D6EF5',
    },
  },
};
